export default __webpack_public_path__ + "media/images/icon_refund-8ad8316dcb424a5ce382d45ac198da86.svg";